module.exports = __webpack_public_path__ + "static/logo-e33d912e19d7173efb5a6708797b0afa.png";